import { catchError, firstValueFrom, tap, forkJoin, map, mergeMap, of, throwError } from "rxjs";
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Navigate } from "@ngxs/router-plugin";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';
import * as FlatFacades from '../../internal';

@Injectable()
export class BulkEditAuthorFacade {
  constructor(protected store: Store,
              protected slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
  }

  //<editor-fold desc="Selectors">

  selectType$ = this.store.select(FlatStates.BulkEditAuthorState.selectType$);
	copyType$ = this.store.select(FlatStates.BulkEditAuthorState.copyType$);
  mediaSet$ = this.store.select(FlatStates.BulkEditAuthorState.mediaSet$);
  
  selectNodeSet$ = this.store.select(FlatStates.BulkEditAuthorState.selectNodeSet$);
  copyNodeSet$ = this.store.select(FlatStates.BulkEditAuthorState.copyNodeSet$);
  pageIdsFromSelectNodeSet$ = this.store.select(FlatStates.BulkEditAuthorState.pageIdsFromSelectNodeSet$);
  // selectedNodeSet$ = this.store.select(FlatStates.BulkEditAuthorState.selectedNodeSet$);
  // hasNotAllowedNodeData$ = this.store.select(FlatStates.BulkEditAuthorState.hasNotAllowedNodeData$);
  // onlySlidesAndTrainings$ = this.store.select(FlatStates.BulkEditAuthorState.onlySlidesAndTrainings$);
  selectPageSet$ = this.store.select(FlatStates.BulkEditAuthorState.selectPageSet$);
	selectPages$ = this.store.select(FlatStates.BulkEditAuthorState.selectPages$);
  copyPageSet$ = this.store.select(FlatStates.BulkEditAuthorState.copyPageSet$);
  copyPages$ = this.store.select(FlatStates.BulkEditAuthorState.copyPages$);
  selectLayerSet$ = this.store.select(FlatStates.BulkEditAuthorState.currentSelectedSelectLayerSet$);
  copyLayerSet$ = this.store.select(FlatStates.BulkEditAuthorState.copyLayerSet$);
  selectImageSet$ = this.store.select(FlatStates.BulkEditAuthorState.currentSelectedSelectImageSet$);
  copyImageSet$ = this.store.select(FlatStates.BulkEditAuthorState.copyImageSet$);
  selectGroupSet$ = this.store.select(FlatStates.BulkEditAuthorState.currentSelectedSelectGroupSet$);
  copyGroupSet$ = this.store.select(FlatStates.BulkEditAuthorState.copyGroupSet$);
  selectAnnotationSet$ = this.store.select(FlatStates.BulkEditAuthorState.currentSelectedSelectAnnotationSet$);
  copyAnnotationSet$ = this.store.select(FlatStates.BulkEditAuthorState.copyAnnotationSet$);
  selectQuestionSet$ = this.store.select(FlatStates.BulkEditAuthorState.currentSelectedSelectQuestionSet$);
  copyQuestionSet$ = this.store.select(FlatStates.BulkEditAuthorState.copyQuestionSet$);
  selectPoiSet$ = this.store.select(FlatStates.BulkEditAuthorState.currentSelectedSelectPoiSet$);
  copyPoiSet$ = this.store.select(FlatStates.BulkEditAuthorState.copyPoiSet$);
  
  nodesVisible$ = this.store.select(FlatStates.BulkEditAuthorState.nodesVisible$);
  slideBulkEditItemCount$ = this.store.select(FlatStates.BulkEditAuthorState.slideBulkEditItemCount$);
  slideBulkCopyItemCount$ = this.store.select(FlatStates.BulkEditAuthorState.slideBulkCopyItemCount$);

  //</editor-fold>
  
  // Node
  hasBulkEditNode$ = (id: string) => this.store.select(FlatStates.BulkEditAuthorState.hasBulkEditNode$).pipe(map(filterFn => filterFn(id)));
  
  //</editor-fold>
  
  //<editor-fold desc="Snapshot Selectors">
  
  snapshot_selectType = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.selectType$);
  snapshot_copyType = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyType$);
	snapshot_mediaSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.mediaSet$);
	snapshot_hasUsedIn = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.hasUsedIn$);
  snapshot_medias = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.medias$);
  snapshot_selectNodeSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.selectNodeSet$);
	snapshot_copyNodeSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyNodeSet$);
	snapshot_nodesVisible = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.nodesVisible$);
  snapshot_selectPageSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.selectPageSet$);
	snapshot_copyPageSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyPageSet$);
	
	snapshot_copyLayerSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyLayerSet$);
	snapshot_copyImageSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyImageSet$);
	snapshot_copyGroupSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyGroupSet$);
	snapshot_copyAnnotationSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyAnnotationSet$);
	snapshot_copyQuestionSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyQuestionSet$);
	snapshot_copyPoiSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyPoiSet$);
	
	snapshot_slideBulkCopyItemCount = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.slideBulkCopyItemCount$);
	snapshot_pageIdsFromSelectNodeSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.pageIdsFromSelectNodeSet$);
  
  snapshot_currentSelectedSelectLayerSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.currentSelectedSelectLayerSet$);
  snapshot_currentSelectedSelectImageSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.currentSelectedSelectImageSet$);
  snapshot_currentSelectedSelectGroupSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.currentSelectedSelectGroupSet$);
  snapshot_currentSelectedSelectAnnotationSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.currentSelectedSelectAnnotationSet$);
  snapshot_currentSelectedSelectQuestionSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.currentSelectedSelectQuestionSet$);
  snapshot_currentSelectedSelectPoiSet = () => this.store.selectSnapshot(FlatStates.BulkEditAuthorState.currentSelectedSelectPoiSet$);
  
  //</editor-fold>
  
  //<editor-fold desc="Requests">
  requestDeselectSelection() {
    return of({}).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.ResetSelection())
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.QuestionEntityActions.SetQuestionId(null))
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.AnnotationGroupEntityActions.SetGroupId(null))
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.PointOfInterestEntityActions.SetPoiId(null))
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.AnnotationEntityActions.SetAnnotationId(null))
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.SlideAuthorActions.SetEditPanelDisplay(FlatModels.SlideAuthorModels.EditPanelDisplay.enum.image))
      ),
    );
  }
  
  requestCopySelection() {
    const selectType = this.snapshot_selectType();
    
    // Add Selection
    switch (selectType) {
      case FlatModels.BulkEditAuthorModels.BulkEditEntityType.enum.PAGE_ENTITY:
        return this.requestCopyPagesFromSelectSet();
      case FlatModels.BulkEditAuthorModels.BulkEditEntityType.enum.LAYER_ENTITY:
        return this.requestCopyLayersFromSelectSet();
      case FlatModels.BulkEditAuthorModels.BulkEditEntityType.enum.IMAGE_ENTITY:
        return this.requestCopyImagesFromSelectSet();
      case FlatModels.BulkEditAuthorModels.BulkEditEntityType.enum.ANNOTATION_ENTITY:
        return this.requestCopyAnnotationsFromSelectSet();
      case FlatModels.BulkEditAuthorModels.BulkEditEntityType.enum.ANNOTATION_GROUP_ENTITY:
        return this.requestCopyGroupsFromSelectSet();
      case FlatModels.BulkEditAuthorModels.BulkEditEntityType.enum.POINT_OF_INTEREST_ENTITY:
        return this.requestCopyPoisFromSelectSet();
      case FlatModels.BulkEditAuthorModels.BulkEditEntityType.enum.QUESTION_ENTITY:
        return this.requestCopyQuestionsFromSelectSet();
      default:
        throw new FlatModels.ErrorControlModels.MedsurfError(
          'notification.type_not_supported',
          FlatModels.ErrorControlModels.ErrorLevel.enum.error,
          FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
          "LIBS.FlatFacades.BulkEditAuthorFacade.requestCopySelection"
        );
    }
  }
  
  requestPasteSelection() {
    const page = structuredClone(this.store.selectSnapshot(FlatStates.PageEntityState.currentSelectedSlidePage$));
    const layer = structuredClone(this.store.selectSnapshot(FlatStates.SlideLayerEntityState.currentSelectedSlideLayer$)) || null;
    const image = structuredClone(this.store.selectSnapshot(FlatStates.ImageEntityState.currentSelectedSlideImage$)) || null;
    switch (this.snapshot_copyType()) {
      case FlatModels.EntityControlModels.EntityQueryType.enum.MEDIA_ENTITY:
      case FlatModels.EntityControlModels.EntityQueryType.enum.NODE_ENTITY:
      case FlatModels.EntityControlModels.EntityQueryType.enum.PAGE_ENTITY:
      case FlatModels.EntityControlModels.EntityQueryType.enum.CHOICE_ENTITY:
        throw new FlatModels.ErrorControlModels.MedsurfError(
          'notification.not_implemented',
          FlatModels.ErrorControlModels.ErrorLevel.enum.error,
          FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
          "LIBS.FlatFacades.BulkEditAuthorFacade.requestPasteSelection"
        );
      case FlatModels.EntityControlModels.EntityQueryType.enum.LAYER_ENTITY:
        return this.requestPasteLayers(page as FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training, true);
      case FlatModels.EntityControlModels.EntityQueryType.enum.IMAGE_ENTITY:
        return this.requestPasteImages(page as FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training, layer, true, true);
      case FlatModels.EntityControlModels.EntityQueryType.enum.ANNOTATION_GROUP_ENTITY:
        return this.requestPasteGroups(page as FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training);
      case FlatModels.EntityControlModels.EntityQueryType.enum.ANNOTATION_ENTITY:
        return this.requestPasteAnnotations(page as FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training, image, null);
      case FlatModels.EntityControlModels.EntityQueryType.enum.QUESTION_ENTITY:
        return this.requestPasteQuestions(page as FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training);
      case FlatModels.EntityControlModels.EntityQueryType.enum.POINT_OF_INTEREST_ENTITY:
        return this.requestPastePois(page as FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training, (image ? [image] : null), true);
      default:
        throw new FlatModels.ErrorControlModels.MedsurfError(
          'notification.type_not_supported',
          FlatModels.ErrorControlModels.ErrorLevel.enum.error,
          FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
          "LIBS.FlatFacades.BulkEditAuthorFacade.requestPasteSelection"
        );
    }
  }
  
  requestRemoveSelection() {
    switch (this.snapshot_selectType()) {
      case FlatModels.EntityControlModels.EntityQueryType.enum.MEDIA_ENTITY:
      case FlatModels.EntityControlModels.EntityQueryType.enum.NODE_ENTITY:
      case FlatModels.EntityControlModels.EntityQueryType.enum.PAGE_ENTITY:
      case FlatModels.EntityControlModels.EntityQueryType.enum.CHOICE_ENTITY:
        throw new FlatModels.ErrorControlModels.MedsurfError(
          'notification.not_implemented',
          FlatModels.ErrorControlModels.ErrorLevel.enum.error,
          FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
          "LIBS.FlatFacades.BulkEditAuthorFacade.requestRemoveSelection"
        );
      case FlatModels.EntityControlModels.EntityQueryType.enum.LAYER_ENTITY:
        return this.requestRemoveBulkEditLayers();
      case FlatModels.EntityControlModels.EntityQueryType.enum.IMAGE_ENTITY:
        return this.requestRemoveBulkEditImages();
      case FlatModels.EntityControlModels.EntityQueryType.enum.ANNOTATION_GROUP_ENTITY:
        return this.requestRemoveBulkEditGroups();
      case FlatModels.EntityControlModels.EntityQueryType.enum.ANNOTATION_ENTITY:
        return this.requestRemoveBulkEditAnnotations();
      case FlatModels.EntityControlModels.EntityQueryType.enum.QUESTION_ENTITY:
        return this.requestRemoveBulkEditQuestions();
      case FlatModels.EntityControlModels.EntityQueryType.enum.POINT_OF_INTEREST_ENTITY:
        return this.requestRemoveBulkEditPois();
      default:
        throw new FlatModels.ErrorControlModels.MedsurfError(
          'notification.type_not_supported',
          FlatModels.ErrorControlModels.ErrorLevel.enum.error,
          FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
          "LIBS.FlatFacades.BulkEditAuthorFacade.requestRemoveSelection"
        );
    }
  }
  
  //<editor-fold desc="Media">
  
  requestToggleMedia(id: string) {
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.loading)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.MediaAuthorActions.GetMediasByIds([id]))
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.ToggleMedia(id))
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }
  
  requestDeselectMedias() {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetMedias([]));
  }
  
  requestRemoveMedia(id: string) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.RemoveMedia(id));
  }
  
  requestRemoveBulkEditMedias() {
    // Get Data
    const mediaSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.mediaSet$);
    
    // Remove All Medias
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.saving)).pipe(
      mergeMap(() =>
        FlatFacades.MediaEntityFacade.removeMedias(this.store, Array.from(mediaSet))
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }
  
  //</editor-fold>
  
  //<editor-fold desc="Node">

  requestToggleNode(id: string,
                    parentId: string | null,
                    navigateToParent = false) {
    // Add Node
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.loading)).pipe(
      tap(async () => {
        if (!navigateToParent) return;
        const currentSelectedNode = await this.slideAuthorFacade.snapshot_currentSelectedNode();
        if (!parentId || parentId === currentSelectedNode?.id) return;
        
        const parentNode = await firstValueFrom(this.slideAuthorFacade.node$(parentId));
        const parentNodeUrl = await firstValueFrom(this.slideAuthorFacade.slideUrlByNode$(parentNode));
        this.store.dispatch(new Navigate(parentNodeUrl[0].split('/')));
      }),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.NodeControlActions.GetNodeById(id))
      ),
      mergeMap((result) => {
        // Get Data
        const typedNodes = this.store.selectSnapshot(FlatStates.NodeEntityState.typedEntities$);
        // Get Node
        const node = typedNodes[id];
        if (node && node.page) {
          return this.store.dispatch(new FlatActions.SlideControlActions.GetSlideDataByPageId(node.page))
        }
        return of(result);
      }),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.ToggleNode(id, parentId))
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }
  
  requestDeselectNodes() {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetNodes([]));
  }
  
  requestSetNodes(ids: string[]) {
    // Add Nodes
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.loading)).pipe(
      mergeMap(() =>
        forkJoin(ids.map(id => this.store.dispatch(new FlatActions.NodeControlActions.GetNodeById(id))))
      ),
      mergeMap((result) =>
        forkJoin(ids.map(id => {
          // Get Data
          const typedNodes = this.store.selectSnapshot(FlatStates.NodeEntityState.typedEntities$);
          // Get Node
          const node = typedNodes[id];
          if (node && node.page) {
            return this.store.dispatch(new FlatActions.SlideControlActions.GetSlideDataByPageId(node.page))
          }
          return of(result);
        })),
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetNodes(ids))
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }
  
  requestCopyNode(id: string) {
    return this.store.dispatch(new FlatActions.NodeControlActions.GetNodeById(id)).pipe(
      mergeMap((result) => {
        // Get Data
        const typedNodes = this.store.selectSnapshot(FlatStates.NodeEntityState.typedEntities$);
        // Get Node
        const node = typedNodes[id];
        if (node && node.page) {
          return this.store.dispatch(new FlatActions.SlideControlActions.GetSlideDataByPageId(node.page))
        }
        return of(result);
      }),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyNodes(new Set<string>([id])))
      ),
    );
  }
  
  requestCopyNodesFromSelectSet() {
    const selectNodeSet = this.snapshot_selectNodeSet();
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyNodes(selectNodeSet));
  }


  requestRemoveNodes(ids: string[]) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.RemoveNodes(ids));
  }
  
  requestDetachNode(node: FlatModels.NodeEntityModels.NodeEntityType) {
    // Check Node
    if (!node) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.node_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatFacades.BulkEditAuthorFacade.requestDetachNode"
      );
    }
    
    // Detach Nodes
    return FlatFacades.NodeEntityFacade.detachNode(this.store, node.id).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history_snapshot_attach_bulk_edit_selected_nodes',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      )
    );
  }
  
  requestDetachNodes() {
    // Get Data
    const selectNodeSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.selectNodeSet$);
    
    // Detach Nodes
    return FlatFacades.NodeEntityFacade.detachNodes(this.store, Array.from(selectNodeSet)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history_snapshot_attach_bulk_edit_selected_nodes',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      )
    );
  }
  
  requestDuplicateNode(node: FlatModels.NodeEntityModels.NodeEntityType,
                       parentNode: FlatModels.NodeEntityModels.NodeEntityType,
                       asTraining: boolean,
                       withAnnotations: boolean) {
    // Check Node
    if (!node) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.node_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatFacades.BulkEditAuthorFacade.requestDuplicateNode"
      );
    }
    
    // Check Parent Node
    if (!parentNode) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.parent_node_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatFacades.BulkEditAuthorFacade.requestDuplicateNode"
      );
    }
    
    // Create Mappings
    const mappings: FlatModels.BulkEditAuthorModels.BulkEditMapping = {
      page: {},
      layer: {},
      image: {},
      group: {},
      poi: {},
      annotation: {},
    };
    
    // Copy Node
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.loading)).pipe(
      mergeMap(() =>
        FlatFacades.NodeEntityFacade.copyNodes(this.store, mappings, [node.id], structuredClone(parentNode), asTraining, withAnnotations)
      ),
      mergeMap((selectIds) =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history_snapshot_attach_bulk_edit_selected_nodes',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        )).pipe(
          mergeMap(() => of(selectIds))
        ),
      ),
      mergeMap((selectIds) => {
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetNodes(selectIds));
        this.store.dispatch(new FlatActions.SlideAuthorActions.ScrollNodeTreeElementIntoView(selectIds[0]));
        return of(selectIds);
      }),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }
  
  requestDuplicateNodes(parentNode: FlatModels.NodeEntityModels.NodeEntityType,
                        asTraining: boolean,
                        withAnnotations: boolean) {
    // Check Parent Node
    if (!parentNode) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.parent_node_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatFacades.BulkEditAuthorFacade.requestDuplicateNodes"
      );
    }
    
    // Get Nodes
    const selectNodeSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.selectNodeSet$);
    
    // Create Mappings
    const mappings: FlatModels.BulkEditAuthorModels.BulkEditMapping = {
      page: {},
      layer: {},
      image: {},
      group: {},
      poi: {},
      annotation: {},
    };
    
    // Copy all Nodes
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.loading)).pipe(
      mergeMap(() =>
        FlatFacades.NodeEntityFacade.copyNodes(this.store, mappings, Array.from(selectNodeSet), structuredClone(parentNode), asTraining, withAnnotations)
      ),
      mergeMap((selectIds) =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history_snapshot_attach_bulk_edit_selected_nodes',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        )).pipe(
          mergeMap(() => of(selectIds))
        ),
      ),
      mergeMap((selectIds) => {
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetNodes(selectIds));
        this.store.dispatch(new FlatActions.SlideAuthorActions.ScrollNodeTreeElementIntoView(selectIds[0]));
        return of(selectIds);
      }),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }
  
  requestPasteNodes(parentNode: FlatModels.NodeEntityModels.NodeEntityType,
                    asTraining: boolean | null,
                    withAnnotations: boolean) {
    // Check Parent Node
    if (!parentNode) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.parent_node_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatFacades.BulkEditAuthorFacade.requestPasteNodes"
      );
    }
    
    // Get Data
    const copyNodeSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyNodeSet$);
    
    // Create Mappings
    const mappings: FlatModels.BulkEditAuthorModels.BulkEditMapping = {
      page: {},
      layer: {},
      image: {},
      group: {},
      poi: {},
      annotation: {},
    };
    
    // Copy all Nodes
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.loading)).pipe(
      mergeMap(() =>
        FlatFacades.NodeEntityFacade.copyNodes(this.store, mappings, Array.from(copyNodeSet), structuredClone(parentNode), asTraining, withAnnotations)
      ),
      mergeMap((selectIds) =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history_snapshot_attach_bulk_edit_selected_nodes',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        )).pipe(
          mergeMap(() => of(selectIds))
        ),
      ),
      mergeMap((selectIds) => {
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetNodes(selectIds));
        this.store.dispatch(new FlatActions.SlideAuthorActions.ScrollNodeTreeElementIntoView(selectIds[0]));
        return of(selectIds);
      }),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }

  requestRemoveBulkEditNodes() {
    // Get Data
    const selectNodeSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.selectNodeSet$);
    const elearnings = structuredClone(this.store.selectSnapshot(FlatStates.NodeEntityState.elearnings$));

    // Remove All Nodes
    return FlatFacades.NodeEntityFacade.removeNodes(this.store, Array.from(selectNodeSet), elearnings).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.bulk_edit.nodes_remove',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
    );
  }
  
  requestToggleVisibilities(hidden: boolean) {
    // Get Data
    const selectNodeSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.selectNodeSet$);
    const typedNodes = this.store.selectSnapshot(FlatStates.NodeEntityState.typedEntities$);
    
    // Update Node Visibility
    return of(Array.from(selectNodeSet)).pipe(
      mergeMap((nodes) =>
        forkJoin(nodes.map((node => {
          const entity = structuredClone(typedNodes[node]);
          if (entity) {
            entity.hidden = hidden
            return this.store.dispatch(new FlatActions.NodeEntityActions.UpdateEntity(entity));
          }
          return of(node);
        }))),
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history_snapshot_toggle_visibilities_bulk_edit_selected_nodes',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      )
    );
  }

  //</editor-fold>
  
  //<editor-fold desc="Page">
  
  requestResetPages() {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetPages([])).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyPages(new Set()))
      ),
    )
  }

  requestTogglePage(id: string) {
    return this.store.dispatch(new FlatActions.SlideControlActions.GetSlideDataByPageId(id)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.TogglePage(id))
      ),
    );
  }
  
  requestDeselectPages() {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetPages([]));
  }

  requestSetPages(ids: string[]) {
    return forkJoin(ids.map(id => this.store.dispatch(new FlatActions.SlideControlActions.GetSlideDataByPageId(id)))).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetPages(ids))
      ),
    );
  }
  
  requestCopyPagesFromSelectSet() {
    const selectPageSet = this.snapshot_selectPageSet();
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyPages(selectPageSet));
  }

  requestRemovePage(id: string) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.RemovePage(id));
  }

  requestRemovePages(ids: string[]) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.RemovePages(ids));
  }
  
  requestAttachPages(parentNode: FlatModels.NodeEntityModels.NodeEntityType) {
    // Check Parent Node
    if (!parentNode) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.parent_node_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatFacades.BulkEditAuthorFacade.requestAttachNodes"
      );
    }
    
    // Get Data
    const copyPageSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyPageSet$);
    
    // Copy all Nodes
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.loading)).pipe(
      mergeMap(() =>
        FlatFacades.PageEntityFacade.attachDetachedPages(this.store, Array.from(copyPageSet), structuredClone(parentNode))
      ),
      mergeMap((selectIds) =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history_snapshot_attach_bulk_edit_selected_nodes',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        )).pipe(
          mergeMap(() => of(selectIds))
        ),
      ),
      mergeMap((selectIds) => {
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetNodes(selectIds));
        this.store.dispatch(new FlatActions.SlideAuthorActions.ScrollNodeTreeElementIntoView(selectIds[0]));
        return of(selectIds);
      }),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }
  
  requestAttachSelectedPagesToNodes(parentNodes: FlatModels.NodeEntityModels.NodeEntityType[]) {
    // Check Parent Nodes
    if (!parentNodes || parentNodes.length === 0) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.parent_nodes_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatFacades.BulkEditAuthorFacade.requestAttachSelectedPagesToNodes"
      );
    }
    
    // Get Data
    const selectPageSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.selectPageSet$);
    
    // Copy all Nodes To Pages
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.loading)).pipe(
      mergeMap(() =>
        forkJoin(parentNodes.map(parentNode => FlatFacades.PageEntityFacade.attachDetachedPages(this.store, Array.from(selectPageSet), structuredClone(parentNode))))
      ),
      mergeMap((selectIdsArray) => {
        const selectIds = selectIdsArray.reduce((arr, ids) => {
          arr.push(...ids);
          return arr;
        }, [] as string[]);
        return of(selectIds);
      }),
      mergeMap((selectIds) =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history_snapshot_attach_bulk_edit_selected_nodes',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        )).pipe(
          mergeMap(() => of(selectIds))
        ),
      ),
      mergeMap((selectIds) => {
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetNodes(selectIds));
        this.store.dispatch(new FlatActions.SlideAuthorActions.ScrollNodeTreeElementIntoView(selectIds[0]));
        return of(selectIds);
      }),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }

  requestRemoveBulkEditPages() {
    // Get Data
    const pageSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.selectPageSet$);

    // Remove All Pages
    return FlatFacades.PageEntityFacade.removePages(this.store, Array.from(pageSet)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.bulk_edit.pages_remove',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
    );
  }

  //</editor-fold>

  //<editor-fold desc="Layer">

  requestToggleLayer(id: string) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.ToggleLayer(id));
  }
  
  requestCopyLayer(id: string) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyLayers(new Set<string>([id])));
  }
  
  requestCopyLayersFromSelectSet() {
    const selectLayerSet = this.snapshot_currentSelectedSelectLayerSet();
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyLayers(selectLayerSet));
  }
  
  requestPasteLayers(page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training,
                     withAnnotations = true) {
    // Check Page
    if (!page) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.page_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatFacades.BulkEditAuthorFacade.requestPasteLayers"
      );
    }
    
    // Get Data
    const typedLayers = this.store.selectSnapshot(FlatStates.SlideLayerEntityState.typedEntities$);
    const typedImages = this.store.selectSnapshot(FlatStates.ImageEntityState.typedEntities$);
    const copyLayerSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyLayerSet$);
    
    // Get Image Pois
    const poiSet = new Set<string>();
    Array.from(copyLayerSet).forEach((layer: string) => {
      const layerEntity = typedLayers[layer];
      if (layerEntity) {
        layerEntity.images.forEach((image: string) => {
          const imageEntity = typedImages[image];
          if (imageEntity) {
            imageEntity.pois.forEach((poi: string) => poiSet.add(poi));
          }
        });
      }
    });
    const pois = Array.from(poiSet);
    
    // Create Mappings
    const mappings: FlatModels.BulkEditAuthorModels.BulkEditMapping = {
      page: {},
      layer: {},
      image: {},
      group: {},
      poi: {},
      annotation: {},
    };
    
    // Copy all Layers
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.loading)).pipe(
      mergeMap(() =>
        FlatFacades.LayerEntityFacade.copyLayers(this.store, mappings, Array.from(copyLayerSet), page, false, withAnnotations, true)
      ),
      mergeMap((selectIds) =>
        FlatFacades.PoiEntityFacade.copyPois(this.store, mappings, pois, page, null, withAnnotations, true).pipe(
          mergeMap(() => of(selectIds))
        ),
      ),
      mergeMap((selectIds) =>
        this.store.dispatch(new FlatActions.PageEntityActions.UpdateEntity(page)).pipe(
          mergeMap(() => of(selectIds))
        ),
      ),
      mergeMap((selectIds) =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history_snapshot_copy_bulk_edit_selected_layers',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        )).pipe(
          mergeMap(() => of(selectIds))
        ),
      ),
      mergeMap((selectIds) => {
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetLayers(selectIds));
        this.store.dispatch(new FlatActions.SlideAuthorActions.SetEditPanelDisplay(FlatModels.SlideAuthorModels.EditPanelDisplay.enum.layer, true));
        this.store.dispatch(new FlatActions.SlideAuthorActions.ScrollSlideTreeElementIntoView(selectIds[0]));
        return of(selectIds);
      }),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }

  requestRemoveBulkEditLayers() {
    // Get Data
    const selectLayerSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.currentSelectedSelectLayerSet$);

    // Remove All Layers
    return FlatFacades.LayerEntityFacade.removeLayers(this.store, Array.from(selectLayerSet)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.bulk_edit.layers_remove',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
      mergeMap(() =>
        this.slideAuthorFacade.requestSetImageIndex(0, 0)
      )
    );
  }

  //</editor-fold>

  //<editor-fold desc="Group">

  requestToggleGroup(id: string) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.ToggleGroup(id));
  }
  
  requestCopyGroup(id: string) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyGroups(new Set<string>([id])));
  }
  
  requestCopyGroupsFromSelectSet() {
    const selectGroupSet = this.snapshot_currentSelectedSelectGroupSet();
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyGroups(selectGroupSet));
  }
  
  requestPasteGroups(page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training) {
    // Check Page
    if (!page) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.page_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatFacades.BulkEditAuthorFacade.requestPasteGroups"
      );
    }
    
    // Get Data
    const typedGroups = this.store.selectSnapshot(FlatStates.AnnotationGroupEntityState.typedEntities$);
    const copyGroupSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyGroupSet$);
    
    // Get Annotation Mapping
    const annotationMappings: { [id: string]: string } = {};
    Array.from(copyGroupSet).forEach((group: string) => {
      const entity = typedGroups[group];
      if (entity) {
        entity.annotations.forEach(annotation => {
          if (page.annotations.includes(annotation)) {
            annotationMappings[annotation] = annotation;
          }
        });
      }
    });
    
    // Create Mappings
    const mappings: FlatModels.BulkEditAuthorModels.BulkEditMapping = {
      page: {},
      layer: {},
      image: {},
      group: {},
      poi: {},
      annotation: annotationMappings,
    };
    
    // Copy all Groups
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.loading)).pipe(
      mergeMap(() =>
        FlatFacades.GroupEntityFacade.copyGroups(this.store, mappings, Array.from(copyGroupSet), page, true)
      ),
      mergeMap((selectIds) =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history_snapshot_copy_bulk_edit_selected_groups',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        )).pipe(
          mergeMap(() => of(selectIds))
        ),
      ),
      mergeMap((selectIds) => {
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetGroups(selectIds));
        this.store.dispatch(new FlatActions.SlideAuthorActions.SetEditPanelDisplay(FlatModels.SlideAuthorModels.EditPanelDisplay.enum.group, true))
        this.store.dispatch(new FlatActions.SlideAuthorActions.ScrollSlideTreeElementIntoView(selectIds[0]));
        return of(selectIds);
      }),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }

  requestRemoveBulkEditGroups() {
    // Get Data
    const selectGroupSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.currentSelectedSelectGroupSet$);

    // Remove All Groups
    return FlatFacades.GroupEntityFacade.removeGroups(this.store, Array.from(selectGroupSet)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.bulk_edit.groups_remove',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
    );
  }

  //</editor-fold>

  //<editor-fold desc="Image">

  requestToggleImage(id: string) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.ToggleImage(id));
  }
  
  requestCopyImage(id: string) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyImages(new Set<string>([id])));
  }
  
  requestCopyImagesFromSelectSet() {
    const selectImageSet = this.snapshot_currentSelectedSelectImageSet();
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyImages(selectImageSet));
  }
  
  requestPasteImages(page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training,
                     layer: FlatModels.LayerEntityModels.Layer,
                     withPois = true,
                     withAnnotations = true) {
    // Check Page
    if (!layer) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.layer_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatFacades.BulkEditAuthorFacade.requestPasteImages"
      );
    }
    
    // Get Data
    const copyImageSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyImageSet$);
    
    // Create Mappings
    const mappings: FlatModels.BulkEditAuthorModels.BulkEditMapping = {
      page: {},
      layer: {},
      image: {},
      group: {},
      poi: {},
      annotation: {},
    };
    
    // Copy all Images
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.loading)).pipe(
      mergeMap(() =>
        FlatFacades.ImageEntityFacade.copyImages(this.store, mappings, Array.from(copyImageSet), page, layer, withPois, withAnnotations)
      ),
      mergeMap((selectIds) =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history_snapshot_copy_bulk_edit_selected_images',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        )).pipe(
          mergeMap(() => of(selectIds))
        ),
      ),
      mergeMap((selectIds) => {
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetImages(selectIds));
        this.store.dispatch(new FlatActions.SlideAuthorActions.SetEditPanelDisplay(FlatModels.SlideAuthorModels.EditPanelDisplay.enum.image, true));
        this.store.dispatch(new FlatActions.SlideAuthorActions.ScrollSlideTreeElementIntoView(selectIds[0]));
        return of(selectIds);
      }),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }

  requestRemoveBulkEditImages() {
    // Get Data
    const selectImageSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.currentSelectedSelectImageSet$);

    // Remove All Images
    return FlatFacades.ImageEntityFacade.removeImages(this.store, Array.from(selectImageSet)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.bulk_edit.images_remove',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
      mergeMap(() =>
        this.slideAuthorFacade.requestSetImageIndex(0, 0)
      )
    );
  }

  //</editor-fold>

  //<editor-fold desc="Annotation">
  
  requestToggleAnnotation(id: string) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.ToggleAnnotation(id));
  }
  
  requestCopyAnnotation(id: string) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyAnnotations(new Set<string>([id])));
  }
  
  requestCopyAnnotationsFromSelectSet() {
    const selectAnnotationSet = this.snapshot_currentSelectedSelectAnnotationSet();
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyAnnotations(selectAnnotationSet));
  }
  
  requestPasteAnnotations(page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training,
                          image: FlatModels.ImageEntityModels.Image | null,
                          currentPositionAndZoom: FlatModels.AnnotationEntityModels.PositionAndZoom | null) {
    // Check Page
    if (!page) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.page_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatFacades.BulkEditAuthorFacade.requestPasteAnnotations"
      );
    }
    
    // Get Data
    const copyAnnotationSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyAnnotationSet$);
    
    // Create Mappings
    const mappings: FlatModels.BulkEditAuthorModels.BulkEditMapping = {
      page: {},
      layer: {},
      image: {},
      group: {},
      poi: {},
      annotation: {},
    };
    
    // Copy all Annotations
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.loading)).pipe(
      mergeMap(() =>
        FlatFacades.AnnotationEntityFacade.copyAnnotations(this.store, mappings, Array.from(copyAnnotationSet), page, image, currentPositionAndZoom)
      ),
      mergeMap((selectIds) =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history_snapshot_copy_bulk_edit_selected_annotations',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        )).pipe(
          mergeMap(() => of(selectIds))
        ),
      ),
      mergeMap((selectIds) => {
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetAnnotations(selectIds));
        this.store.dispatch(new FlatActions.SlideAuthorActions.SetEditPanelDisplay(FlatModels.SlideAuthorModels.EditPanelDisplay.enum.annotation, true));
        this.store.dispatch(new FlatActions.SlideAuthorActions.ScrollSlideTreeElementIntoView(selectIds[0]));
        return of(selectIds);
      }),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }

  requestRemoveBulkEditAnnotations() {
    // Get Data
    const selectAnnotationSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.currentSelectedSelectAnnotationSet$);

    // Remove All Annotations
    return FlatFacades.AnnotationEntityFacade.removeAnnotations(this.store, Array.from(selectAnnotationSet)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.bulk_edit.annotations_remove',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
    );
  }

  //</editor-fold>

  //<editor-fold desc="Question">

  requestToggleQuestion(id: string) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.ToggleQuestion(id));
  }
  
  requestCopyQuestion(id: string) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyQuestions(new Set<string>([id])));
  }
  
  requestCopyQuestionsFromSelectSet() {
    const selectQuestionSet = this.snapshot_currentSelectedSelectQuestionSet();
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyQuestions(selectQuestionSet));
  }
  
  requestPasteQuestions(page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training) {
    // Check Page
    if (!page) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.page_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatFacades.BulkEditAuthorFacade.requestPasteQuestions"
      );
    }
    
    // Get Data
    const copyQuestionSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyQuestionSet$);
    
    // Copy all Questions
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.loading)).pipe(
      mergeMap(() =>
        FlatFacades.QuestionEntityFacade.copyQuestions(this.store, Array.from(copyQuestionSet), page)
      ),
      mergeMap((selectIds) =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history_snapshot_copy_bulk_edit_selected_questions',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        )).pipe(
          mergeMap(() => of(selectIds))
        )
      ),
      mergeMap((selectIds) => {
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetQuestions(selectIds));
        this.store.dispatch(new FlatActions.SlideAuthorActions.SetEditPanelDisplay(FlatModels.SlideAuthorModels.EditPanelDisplay.enum.question, true))
        this.store.dispatch(new FlatActions.SlideAuthorActions.ScrollSlideTreeElementIntoView(selectIds[0]));
        return of(selectIds);
      }),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }

  requestRemoveBulkEditQuestions() {
    // Get Data
    const selectQuestionSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.currentSelectedSelectQuestionSet$);

    // Remove All Questions
    return FlatFacades.QuestionEntityFacade.removeQuestions(this.store, Array.from(selectQuestionSet)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.bulk_edit.questions_remove',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
    );
  }

  //</editor-fold>

  //<editor-fold desc="Poi">

  requestTogglePoi(id: string) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.TogglePoi(id));
  }
  
  requestCopyPoi(id: string) {
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyPois(new Set<string>([id])));
  }
  
  requestCopyPoisFromSelectSet() {
    const selectPoiSet = this.snapshot_currentSelectedSelectPoiSet();
    return this.store.dispatch(new FlatActions.BulkEditAuthorActions.CopyPois(selectPoiSet));
  }
  
  requestPastePois(page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training,
                   images: FlatModels.ImageEntityModels.Image[] | null,
                   withAnnotations = false) {
    // Check Page
    if (!page) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.page_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatFacades.BulkEditAuthorFacade.requestPastePois"
      );
    }
    
    // Get Data
    const typedPois = this.store.selectSnapshot(FlatStates.PointOfInterestEntityState.typedEntities$);
    const copyPoiSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.copyPoiSet$);
    
    // Get Mappings
    const imageMappings: { [id: string]: string } = {};
    const annotationMappings: { [id: string]: string } = {};
    Array.from(copyPoiSet).forEach((poi: string) => {
      const entity = typedPois[poi];
      if (entity) {
        (entity.images || []).forEach(image => {
          imageMappings[image] = image;
        });
        entity.annotationToPointOfInterest.forEach(atpoi => {
          if (page.annotations.includes(atpoi.annotation)) {
            annotationMappings[atpoi.annotation] = atpoi.annotation;
          }
        });
      }
    });
    
    // Create Mappings
    const mappings: FlatModels.BulkEditAuthorModels.BulkEditMapping = {
      page: {},
      layer: {},
      image: imageMappings,
      group: {},
      poi: {},
      annotation: annotationMappings,
    };
    
    // Copy all Pois
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.loading)).pipe(
      mergeMap(() =>
        FlatFacades.PoiEntityFacade.copyPois(this.store, mappings, Array.from(copyPoiSet), page, images, withAnnotations)
      ),
      mergeMap((selectIds) =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history_snapshot_copy_bulk_edit_selected_pois',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        )).pipe(
          mergeMap(() => of(selectIds))
        ),
      ),
      mergeMap((selectIds) => {
        this.store.dispatch(new FlatActions.BulkEditAuthorActions.SetPois(selectIds));
        this.store.dispatch(new FlatActions.SlideAuthorActions.SetEditPanelDisplay(FlatModels.SlideAuthorModels.EditPanelDisplay.enum.poi, true));
        this.store.dispatch(new FlatActions.SlideAuthorActions.ScrollSlideTreeElementIntoView(selectIds[0]));
        return of(selectIds);
      }),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));
        
        // Return error
        return throwError(() => {
          return result;
        });
      }),
    );
  }

  requestRemoveBulkEditPois() {
    // Get Data
    const selectPoiSet = this.store.selectSnapshot(FlatStates.BulkEditAuthorState.currentSelectedSelectPoiSet$);

    // Remove All Pois
    return FlatFacades.PoiEntityFacade.removePois(this.store, Array.from(selectPoiSet)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.bulk_edit.pois_remove',
          this.store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
    );
  }

  //</editor-fold>

  //</editor-fold>
}
